var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"touch",rawName:"v-touch:longtap",value:(_vm.emitLongtap(_vm.field)),expression:"emitLongtap(field)",arg:"longtap"}],staticClass:"field",class:{
    'has-bomb': _vm.field.hasBomb && _vm.field.isOpen,
    'is-open': _vm.field.isOpen,
    'is-marked': _vm.field.isMarked
  },attrs:{"data-coordinates":_vm.coordinates}},[_vm._v("\n  "+_vm._s(_vm.field.numNeighbourBombs ? _vm.field.numNeighbourBombs : null)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c8e4b9a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Field.vue
// module id = null
// module chunks = 